import {createSlice} from '@reduxjs/toolkit';

export const applicationSlice = createSlice({
  name: 'application',
  initialState: {
    isShowAlert: false,
    alertText: null,
    severity: null,
    loader: false,
    confirm: {
      open: false,
      message: '',
      title: '',
      okTitle: '',
      cancelTitle: '',
      resolved: false,
      rejected: false
    }
    //isModalDlgOpened: false
  },
  reducers: {
    setErrorInformation: (state, {payload: errorInformation}) => {
      state.alertText = errorInformation;
      state.isShowAlert = true;
      state.severity = 'error';
    },
    setSuccessInformation: (state, {payload: information}) => {
      state.alertText = information;
      state.isShowAlert = true;
      state.severity = 'success';
    },
    closeAlert: state => {
      state.isShowAlert = false;
    },
    toggleLoader: (state, {payload: value}) => {
      state.loader = value;
      //На время выполнения действия дизейблим тыканье юзерами мышкой в компоненты
      document.body.classList.toggle('disable-all', value > 0);
    },
    openConfirm: (state, {payload: {message, title = 'Підтвердження дії', okTitle = 'Підтвердити', cancelTitle = 'Відмінити'}} = {}) => {
      state.confirm.message = message;
      state.confirm.title = title;
      state.confirm.okTitle = okTitle;
      state.confirm.cancelTitle = cancelTitle;
      state.confirm.open = true;
    },
    closeConfirm: state => {
      state.confirm.open = false;
    },
    resolveConfirm: state => {
      state.confirm.resolved = true;
      state.confirm.rejected = false;
      state.confirm.open = false;
    },
    rejectConfirm: state => {
      state.confirm.rejected = true;
      state.confirm.resolved = false;
      state.confirm.open = false;
    }
    //Пока оставил работу с модальными диалогами через реактовский стейт
    /*toggleModal: (state, {payload: value}) => {
      state.isModalDlgOpened = value;
    }*/
  }
});

export const applicationSelector = state => state.application;

export const {
  setErrorInformation, closeAlert, toggleLoader, setSuccessInformation,
  openConfirm, closeConfirm, resolveConfirm, rejectConfirm
} = applicationSlice.actions;



export default applicationSlice.reducer;